var App = App || {};

App.SkipLinks = (function ($) {
    "use strict";

    function init() {

        var $loginDropdown = $("aside.login.dropdown"),
            $loginForm = $("section.login form.login");

        $(".skip-links a.olb").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($loginDropdown.is(":visible")) {
                $loginDropdown
                    .find(".btn.dropdown-toggle")
                    .click();

                $loginDropdown
                    .find("select[name='account-type']")
                    .focus();
            } else {
                $loginForm.each(function () {
                    if ($(this).is(":visible")) {
                        $(this)
                            .find("select[name='account-type']")
                            .focus();
                    }
                });
            }
        });
    }

    return {
        init: init
    }

})(jQuery);

$(function () {
    App.SkipLinks.init();
});